import { ClientShortcuts } from '@components/molecules';
import { isValidUUID } from '@helpers';
import { useNavigationEvents } from '@hooks';
import { CaretRight as CaretRightIcon } from '@phosphor-icons/react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const BreadcrumbItem = ({
	path,
	displayName,
	isLast,

}: {
	path: string;
	displayName: string;
	isLast: boolean;
}) => {
	if (isLast) {
		return (
			<span className='flex items-center gap-1 text-zinc-500'>
				{displayName}
				<CaretRightIcon
					className='w-4 h-4 text-zinc-400 mt-0.5'
					weight='regular'
				/>
			</span>
		);
	}

	return (
		<Link to={path} className='text-blue-800 hover:text-blue-900'>
			{displayName}
		</Link>
	);
};

export const BreadcrumbNavigation = () => {
	const { navigationEvents, currentPath } = useNavigationEvents();

	const breadcrumbItems = navigationEvents.map((event: any) => ({
		title: (
			<BreadcrumbItem
				path={event.path}
				displayName={event.displayName}
				isLast={event.isLast}
			/>
		),
	}));

	const customerId = currentPath.split('/')[2];

	return (
		<>
			<Breadcrumb
				items={breadcrumbItems}
				separator={
					<CaretRightIcon
						className='w-4 h-4 text-zinc-400 mt-1'
						weight='regular'
					/>
				}
				className='text-zinc-400'
			/>
			{currentPath.includes('/clientes/') && isValidUUID(customerId) && (
				<ClientShortcuts customerId={customerId} />
			)}
		</>
	);
};
